import { base64ToBytes, bytesToBase64 } from "./envelope.js";
const ALGORITHM = "AES-GCM";
const IV_LENGTH_BYTES = 12;
export class NetworkDecryptionError extends Error {
    constructor(message) {
        super(message);
        this.name = "NetworkDecryptionError";
    }
}
async function importKey(crypto, base64Key) {
    const rawKey = base64ToBytes(base64Key);
    if (![16, 24, 32].includes(rawKey.byteLength)) {
        throw new Error(`Invalid NETWORK_ENCRYPTION_KEY: decoded to ${rawKey.byteLength} bytes, AES-GCM requires 16, 24 or 32. Generate with: openssl rand -base64 32`);
    }
    return crypto.subtle.importKey("raw", rawKey, ALGORITHM, false, ["encrypt", "decrypt"]);
}
export async function encrypt(crypto, base64Key, payload) {
    const key = await importKey(crypto, base64Key);
    const iv = new Uint8Array(IV_LENGTH_BYTES);
    crypto.getRandomValues(iv);
    const plaintext = new TextEncoder().encode(JSON.stringify(payload));
    const ciphertext = await crypto.subtle.encrypt({ name: ALGORITHM, iv }, key, plaintext);
    return {
        iv: bytesToBase64(iv),
        data: bytesToBase64(new Uint8Array(ciphertext)),
    };
}
export async function decrypt(crypto, base64Key, envelope) {
    try {
        const key = await importKey(crypto, base64Key);
        const iv = base64ToBytes(envelope.iv);
        const ciphertext = base64ToBytes(envelope.data);
        const plaintext = await crypto.subtle.decrypt({ name: ALGORITHM, iv }, key, ciphertext);
        return JSON.parse(new TextDecoder().decode(plaintext));
    }
    catch {
        throw new NetworkDecryptionError("Failed to decrypt payload");
    }
}
